/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { ALIGN, ALIGN_DATA, ILanding, ILandingSection, SELECT_TYPE } from "../../../data/interfaces"
import TextBlock from "../useful/TextBlock" 
import { CSSObjectToString } from "src/libs/utilities"
import getTypographyStyle from "../../utils/getTypographyStyle"

/* Protopia Ecosystem component */
export interface ITitleProps {
   section: ILandingSection
}
const Title = ({section,...props}: ITitleProps): JSX.Element => {  
    const currentLanding: ILanding = useLandingStore( ( state: ILandingStore ) => state.currentLanding )
    const { title } = currentLanding
    const titleData = useMemo(() => ({ ...title, ...section.title }), [ title, section.title ]) 
    const { position } = usePosition( titleData )
    const typography  = section.title.typography  || title.typography
    const beforeStyle = section.title.beforeStyle || title.beforeStyle
    const afterStyle  = section.title.afterStyle  || title.afterStyle
    
    useEffect(() => {
        addCSSClass(
            `section-title-${ section.id }`,
            `.section-title-${ section.id } {
                ${ getTypographyStyle( typography ) } 
            }
            ${ 
                beforeStyle 
                    ? 
                    `.section-title-${section.id}::before { 
                        content: "${
                            beforeStyle.content === "attr(data-text)" 
                                ?
                                titleData.text
                                :
                                beforeStyle.content || "" 
                        }"; 
                        ${ CSSObjectToString(beforeStyle) } 
                    }` 
                    : 
                    `` 
                }
            ${ 
                afterStyle  
                    ? 
                    `.section-title-${section.id}::after  { 
                        content: "${ 
                            afterStyle.content === "attr(data-text)"
                                ?
                                titleData.text
                                :
                                afterStyle.content || "" 
                        }"; 
                        ${ CSSObjectToString(afterStyle) } 
                    }`  
                    : 
                    `` 
                }    
            `
        )
        return () => {
            removeCSSClass( `section-title-${section.id}`)
        } 
    }, [ title, section.title ])

    return section.title?.text || !section.title?.isHidden
        ?
        <div className={`w-100 d-flex ${ ALIGN_DATA[ title.align || ALIGN.MIDDLE ]?.className }`}> 
            <TextBlock 
                editType={ SELECT_TYPE.TITLE }
                section={ section }
                data={ title }
                columns={ 1 }
                text={ `${ section.title.text || "" }` }
                className={`h landing-section-title  ${title.className || ""} section-title-${section.id}`}
                style={{
                    ...(section.title.style || title?.style),
                    ...position.style,
                    ...(section.title.spanStyle || title?.spanStyle),
                    ...position.spanStyle,
                    // textAlign: ALIGN_DATA[ title.align || ALIGN.MIDDLE ]?.align,
                }}
            />
        </div>
        :
        <></>
}
export default Title